import { EC } from "@/constants/errors";

export class LocalError extends Error {
  private code: EC;

  constructor(
    code: EC,
    message?: string | undefined,
    options?: ErrorOptions | undefined,
  ) {
    super(message, options);
    this.code = code;
    return this;
  }
  /**
   * EC: ErrorCode 错误码
   * 错误详情
   * @returns
   */
  toString(): string {
    return `[EC:${this.code}]${super.toString()}`;
  }
}
